import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AssignedModulesResponse } from '../_types';
import { generateAssignedModules } from './performanceReportingDataGenerator';
import { useRiskPoolPerformanceReportingDemo } from '../../../../_data_sources/useRiskPoolPerformanceReportingDemo';

interface UseAssignedModulesParams {
  orgId: string;
  childOrgId: string;
}

export default function useAssignedModules(
  params: UseAssignedModulesParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const useDemoData = useRiskPoolPerformanceReportingDemo();

  return useQuery<AssignedModulesResponse, Error>(
    ['risk_pool_perf_report_assigned_modules', params.orgId, params.childOrgId],
    async (): Promise<AssignedModulesResponse> => {
      try {
        if (useDemoData) {
          const demoData = generateAssignedModules(params.childOrgId);
          console.log('[useAssignedModules] Demo Data Response:', JSON.stringify(demoData, null, 2));
          return demoData;
        }

        const url = `${baseApiUrl()}/organizations/${params.orgId}/risk-pool/related-organizations/${params.childOrgId}/performance-reporting/assigned-modules`;
        const data: AssignedModulesResponse = await fetcher({
          method: 'get',
          url,
        });
        console.log('[useAssignedModules] API Response:', JSON.stringify(data, null, 2));
        return data;
      } catch (err) {
        if (onError) onError(err as ServerErrorResponse);
        throw err;
      }
    },
    {
      ...options,
      enabled: !!params.orgId && !!params.childOrgId,
    }
  );
}

